import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/** Login method name strings (serializable for Redux) */
export type LoginMethodName = 'magicLink' | 'password' | 'webauthn';

export interface ProfileRootState {
    email: string;
    methods: LoginMethodName[];
}

const initialState: ProfileRootState = {
    email: '',
    methods: [],
};

const profileSlice = createSlice({
    name: 'profile',
    initialState: initialState,
    reducers: {
        setEmail: (state, action: PayloadAction<string>) => {
            return { ...state, email: action.payload };
        },
        setAvailableMethods: (
            state,
            action: PayloadAction<LoginMethodName[]>
        ) => {
            return { ...state, methods: action.payload };
        },
        setProfileAuthInfo: (
            state,
            action: PayloadAction<ProfileRootState>
        ) => {
            return {
                ...state,
                ...action.payload,
            };
        },
    },
});

export const { setEmail, setAvailableMethods, setProfileAuthInfo } =
    profileSlice.actions;
export const profileReducer = profileSlice.reducer;
export const selectEmail = (state: { profile: ProfileRootState }) =>
    state.profile.email;
export const selectAvailableMethods = (state: { profile: ProfileRootState }) =>
    state.profile.methods;
export const selectProfileAuthInfo = (state: { profile: ProfileRootState }) =>
    state.profile;
